{
  "companies": {
    "title": "Sociétés",
    "description": "Gérez les entités légales, calendriers et paramètres fiscaux par société.",
    "addCompany": "Ajouter une société",
    "searchPlaceholder": "Rechercher des sociétés…",
    "editCompany": "Modifier la société",
    "newCompany": "Nouvelle société",
    "columns": {
      "code": "Code",
      "name": "Nom",
      "country": "Pays",
      "currency": "Devise",
      "timezone": "Fuseau horaire",
      "default": "Par défaut",
      "actions": "Opérations"
    },
    "yes": "Oui",
    "no": "Non",
    "edit": "Modifier",
    "calendar": "Calendrier",
    "workCalendar": {
      "title": "Calendrier de travail",
      "titleWithCompany": "Calendrier de travail — {{name}}",
      "assignPattern": "Attribuer un modèle de semaine",
      "assignPatternDesc": "Choisissez un modèle enregistré et appliquez-le au calendrier de travail de cette société.",
      "weekPatternMaster": "Modèle de semaine",
      "selectPattern": "Sélectionner un modèle…",
      "noPatterns": "Aucun modèle — créez-en un ci-dessous",
      "assignButton": "Attribuer au calendrier de travail",
      "weekPatternSection": "Modèle de semaine",
      "weekPatternSectionDesc": "Définissez les jours ouvrés et les heures par défaut. Réutilisable dans les plannings et la présence.",
      "holidayTypes": "Types de jours fériés",
      "holidayTypesDesc": "Personnalisez les catégories pour cette société. Ajoutez les dates sous RH → Jours fériés."
    },
    "users": "Utilisateurs",
    "usersTitle": "Association utilisateur-société",
    "depts": "Dépts",
    "deptsTitle": "Accès départements",
    "fields": {
      "name": "Nom",
      "code": "Code",
      "taxRegistration": "N° fiscal",
      "registrationNumber": "N° d'enregistrement",
      "email": "E-mail"
    },
    "toast": {
      "created": "Société créée — vous êtes le premier employé de {{name}}",
      "calendarUpdated": "Calendrier de travail mis à jour"
    },
    "errors": {
      "loadFailed": "Échec du chargement des sociétés",
      "saveFailed": "Échec de l'enregistrement",
      "selectWeekPattern": "Sélectionnez un modèle de semaine",
      "calendarUpdateFailed": "Échec de la mise à jour du calendrier"
    }
  },
  "adminLinks": {
    "organization": {
      "label": "Organisation",
      "description": "Profil, identité visuelle et informations de société"
    },
    "companies": {
      "label": "Sociétés",
      "description": "Entités légales, calendriers et paramètres fiscaux"
    },
    "enterpriseSetup": {
      "label": "Configuration entreprise",
      "description": "Société → Magasin → Entrepôt → Calendrier → RH → Finance"
    },
    "users": {
      "label": "Utilisateurs",
      "description": "Gérer les employés et les accès"
    },
    "roles": {
      "label": "Rôles",
      "description": "Accès aux écrans et modèles de rôle"
    },
    "subscription": {
      "label": "Abonnement",
      "description": "Plans, facturation et utilisation des modules"
    },
    "approvalInbox": {
      "label": "Boîte d'approbation",
      "description": "Demandes en attente, approuvées, rejetées et escaladées"
    },
    "approvalWorkflows": {
      "label": "Flux d'approbation",
      "description": "Créer et gérer les chaînes d'approbation sans code"
    },
    "approvalMatrix": {
      "label": "Matrice d'approbation",
      "description": "Module, action, conditions, approbateurs, SLA, escalade"
    }
  },
  "taxesPage": {
    "description": "Barèmes de taxes par pays liés aux produits via la sélection de taxe dans le formulaire produit.",
    "columns": {
      "taxName": "Nom de taxe",
      "inclusive": "Inclus"
    },
    "toast": {
      "saved": "Taxe enregistrée"
    }
  },
  "taxRules": {
    "columns": {
      "country": "Pays",
      "mode": "Mode",
      "ratePercent": "Taux %",
      "state": "État",
      "status": "Statut",
      "taxName": "Nom de taxe"
    },
    "toast": {
      "saved": "Règle fiscale enregistrée"
    }
  },
  "toast": {
    "displaySettingsSaved": "Affichage date et heure enregistré pour {{company}}",
    "alreadyOnThisPlan": "Already on ce plan",
    "subscriptionUpgraded": "Subscription upgraded",
    "offerSaved": "Offer enregistré",
    "couponSaved": "Coupon enregistré",
    "productDiscountUpdated": "Product discount mis à jour",
    "serialRegistered": "Serial registered",
    "transferCancelled": "Transfer annulé",
    "transferRequestCreatedDraft": "Transfer request créé (draft)",
    "stockAdjustedTrackedInMovements": "Stock adjusted — tracked in Movements",
    "transferCompletedViaWorkflow": "Transfer terminé via flux de travail",
    "transferSubmittedForApproval": "Transfer soumis pour approbation",
    "backorderAllocatedStockReserved": "Backorder allocated — stock reserved",
    "serialRetired": "Serial retired",
    "voidSubmittedForSupervisorApproval": "Void soumis pour supervisor approbation",
    "invoiceRestored": "Facture remagasind",
    "voidReversalSubmittedForApproval": "Void reversal soumis pour approbation",
    "profileUpdated": "Profile mis à jour",
    "alertSavedYouWillGetANotificationWhen": "Alert enregistré — you will get a notification when stock falls à ce level",
    "brandAdded": "Brand ajoutered",
    "unitAdded": "Unit ajoutered",
    "exportedAsCsv": "Exported as CSV",
    "thisIsAlreadyYourCurrentPlan": "This is already votre current plan",
    "requestSentOurTeamWillCreateAPlan": "Request sent — our team will create a plan pour you",
    "userCanNowAccessThisCompany": "User can now access ce company",
    "companyAccessRemoved": "Company access removed",
    "defaultCompanyUpdatedForUser": "Default company mis à jour pour utiliserr",
    "pagePinnedToFavorites": "Page pinned à favorites",
    "planActivated": "{{plan}} activé",
    "upgradedToPlan": "Upgraded à {{plan}}",
    "exportedAs": "Exported as {{format}}",
    "returnProcessed": "Return {{returnNumber}} processed",
    "invoiceVoided": "Facture {{factureNumber}} voided",
    "inventoryReportExported": "Inventory rapport exported ({{format}})",
    "transferAction": "Transfer {{action}}d",
    "modulePlanSet": "{{module}} plan set à {{plan}}",
    "customerActivated": "Client activé",
    "customerDeactivated": "Client désactivé",
    "productActivated": "Produit activé",
    "productDeactivated": "Produit désactivé",
    "brandActivated": "Marque activée",
    "brandDeactivated": "Marque désactivée",
    "unitActivated": "Unité activée",
    "unitDeactivated": "Unité désactivée",
    "employeeCreated": "Employé créé",
    "employeeUpdated": "Employé mis à jour",
    "walletToppedUp": "Portefeuille crédité",
    "walletDebited": "Portefeuille débité",
    "autoRenewEnabled": "Renouvellement automatique activé",
    "autoRenewDisabled": "Renouvellement automatique désactivé",
    "supplierActivated": "Fournisseur activé",
    "supplierDeactivated": "Fournisseur désactivé",
    "supplierSaved": "Fournisseur enregistré",
    "storeActivated": "Magasin activé",
    "storeDeactivated": "Magasin désactivé",
    "storeSaved": "Magasin enregistré",
    "taxRuleActivated": "Tax rule activé",
    "taxRuleDeactivated": "Tax rule désactivé",
    "taxActivated": "Tax activé",
    "taxDeactivated": "Tax désactivé",
    "categoryActivated": "Category activé",
    "categoryDeactivated": "Category désactivé",
    "storeProductActivated": "Magasin produit activé",
    "storeProductDeactivated": "Magasin produit désactivé",
    "roleActivated": "Rôle activé",
    "roleDeactivated": "Rôle désactivé",
    "alertRemoved": "Alerte supprimée",
    "categorySaved": "Catégorie enregistrée",
    "storeProductSaved": "Produit magasin enregistré"
  },
  "errors": {
    "failedToSaveDisplaySettings": "Échec de l'enregistrement de display settings",
    "paymentCouldNotBeStarted": "Paiement could pas be started",
    "failedToLoadBilling": "Échec du chargement de billing",
    "failedToLoadModulePlans": "Échec du chargement de module plans",
    "paymentVerificationFailed": "Échec de payment verification",
    "upgradeFailed": "Échec de upgrade",
    "modulePlanUpdateFailed": "Échec de module plan update",
    "brandNameIsRequired": "Brand name is requis",
    "saveFailed": "Échec de l'enregistrement",
    "enterAPositiveAmount": "Saisissez a positive amount",
    "walletUpdateFailed": "Échec de wallet update",
    "offerNameIsRequired": "Offer name is requis",
    "enterAValidDiscountValue": "Saisissez a valid discount value",
    "percentageCannotExceed100": "Percentage cannot exceed 100",
    "couponCodeIsRequired": "Coupon code is requis",
    "enterAPercentageBetween0And100": "Saisissez a percentage between 0 and 100",
    "updateFailed": "Échec de update",
    "selectACompanyInTheHeaderBeforeAdding": "Sélectionnez un company in the header before adding employees",
    "selectARoleWhenEmailIsProvided": "Sélectionnez un rôle lorsqu'un e-mail est renseigné",
    "reportingManagerIsRequired": "Rapporting responsable is requis",
    "productAndSerialNumberRequired": "Produit et serial number requis",
    "selectDestinationStoreAndProduct": "Select destination magasin et produit",
    "enterAValidQuantity": "Saisissez a valid quantity",
    "failedToLoadReadinessReports": "Échec du chargement de readiness reports",
    "registerSerialFailed": "Échec de register serial",
    "exportFailed": "Échec de l'export",
    "cancelTransferFailed": "Échec de cancel transfer",
    "createTransferRequestFailed": "Échec de create transfer request",
    "adjustFailed": "Échec de adjust",
    "transferFailed": "Échec de transfer",
    "transferActionFailed": "Échec du transfert {{action}}",
    "allocateBackorderFailed": "Échec de allocate backorder",
    "enterReturnQuantitiesForAtLeastOneLine": "Saisissez return quantities for at least one line",
    "failedToLoadInvoice": "Échec du chargement de invoice",
    "returnFailed": "Échec de return",
    "printFailed": "Échec de print",
    "voidFailed": "Échec de void",
    "restoreFailed": "Échec de restore",
    "orgCodeMustBe13UppercaseLetters": "Org code must be 1–3 uppercase letters ou digits",
    "failedToLoadOrganization": "Échec du chargement de organization",
    "selectAProduct": "Sélectionnez un product",
    "failedToLoadAlerts": "Échec du chargement de alerts",
    "removeFailed": "Échec de remove",
    "unitNameIsRequired": "Unit name is requis",
    "skuAndNameAreRequired": "SKU et name are requis",
    "couldNotAddBrand": "Impossible de add brand",
    "couldNotAddUnit": "Impossible de add unit",
    "selectAStoreForFinancialReports": "Sélectionnez un store for financial reports",
    "selectAStoreInTheHeaderForLow": "Sélectionnez un store in the header for low stock report",
    "pdfExcelExportIsAvailableForSalesAnd": "PDF/Excel export is disponible pour Sales et Inventory tabs only",
    "loadProductSalesReportFirst": "Load produit sales rapport first",
    "loadProfitReportFirst": "Load profit rapport first",
    "loadTaxReportFirst": "Load tax rapport first",
    "loadLowStockReportFirst": "Load low stock rapport first",
    "loadExpiryReportFirst": "Load expiry rapport first",
    "loadEmployeeSalesReportFirst": "Load employé sales rapport first",
    "failedToLoadReport": "Échec du chargement de report",
    "roleNameAndCodeAreRequired": "Le nom et le code du rôle sont obligatoires",
    "screenAccessIsStillLoading": "L'accès aux écrans est encore en cours de chargement",
    "failedToLoadRoleScreenAccess": "Échec du chargement de l'accès aux écrans du rôle",
    "failedToLoadRole": "Échec du chargement du rôle",
    "storeAndProductAreRequired": "Magasin et produit are requis",
    "nameAndCodeAreRequired": "Name et code are requis",
    "yourAccountEmailIsRequiredToSubmitA": "Your account email is requis à submit a request",
    "failedToLoadPlans": "Échec du chargement de plans",
    "paymentReceivedButActivationFailedContactSupport": "Paiement received but activation failed. Contact support.",
    "couldNotUpdateAutoRenew": "Impossible de update auto-renew",
    "couldNotSubmitRequest": "Impossible de submit request",
    "taxNameIsRequired": "Tax name is requis",
    "failedToLoadAccessData": "Échec du chargement de access data",
    "failedToLoadDepartmentAccess": "Échec du chargement de department access",
    "failedToLoadCompanyAccess": "Échec du chargement de company access",
    "failedToGrantAccess": "Échec : grant access",
    "failedToRevokeAccess": "Échec : revoke access",
    "failedToSetDefault": "Échec : set default",
    "thisPageIsNotAvailableInYourCurrent": "This page is pas disponible in votre current module.",
    "returnQtyExceedsSold": "Return qty exceeds sold pour {{produit}}",
    "failedToLoadBrands": "Échec du chargement de brands",
    "failedToLoadCategories": "Échec du chargement de categories",
    "failedToLoadCustomers": "Échec du chargement de customers",
    "failedToLoadOffers": "Échec du chargement de offers",
    "failedToLoadCoupons": "Échec du chargement de coupons",
    "failedToLoadProducts": "Échec du chargement de products",
    "failedToLoadEmployees": "Échec du chargement de employees",
    "failedToLoadInventory": "Échec du chargement de inventory",
    "failedToLoadStockMovements": "Échec du chargement de stock movements",
    "failedToLoadTransferRequests": "Échec du chargement de transfer requests",
    "failedToLoadBackorders": "Échec du chargement de backorders",
    "failedToLoadSerialNumbers": "Échec du chargement de serial numbers",
    "failedToLoadInvoices": "Échec du chargement de invoices",
    "failedToLoadRoles": "Échec du chargement des rôles",
    "failedToLoadStoreProducts": "Échec du chargement de store products",
    "failedToLoadStores": "Échec du chargement de stores",
    "failedToLoadSuppliers": "Échec du chargement de suppliers",
    "failedToLoadTaxes": "Échec du chargement de taxes",
    "failedToLoadTaxRules": "Échec du chargement de tax rules",
    "failedToLoadUnits": "Échec du chargement de units",
    "activateFailed": "Échec de l'activation",
    "deactivateFailed": "Échec de la désactivation",
    "createFailed": "Échec de la création",
    "passwordsMismatch": "Les mots de passe ne correspondent pas"
  },
  "roles": {
    "addRole": "Ajouter un rôle",
    "columns": {
      "type": "Catégorie",
      "roleName": "Nom du rôle",
      "code": "Code",
      "description": "Descriptif",
      "status": "Statut",
      "screenAccess": "Accès aux écrans",
      "screensCount": "{{visible}}/{{total}} écrans",
      "builtIn": "Intégré",
      "custom": "Personnalisé"
    },
    "actions": {
      "view": "Voir",
      "edit": "Modifier",
      "close": "Fermer",
      "editScreenAccess": "Modifier l'accès aux écrans",
      "save": "Enregistrer",
      "createRole": "Créer le rôle"
    },
    "viewModal": {
      "title": "{{name}} — accès aux écrans",
      "titleFallback": "Accès aux écrans du rôle",
      "loading": "Chargement…",
      "codeLabel": "Code :",
      "descriptionLabel": "Description :",
      "screensLabel": "Écrans :",
      "screensVisible": "{{visible}}/{{total}} visibles"
    },
    "editModal": {
      "editBuiltIn": "Modifier l'accès aux écrans de {{name}}",
      "editRole": "Modifier le rôle",
      "newRole": "Nouveau rôle",
      "activeRole": "Rôle actif",
      "builtInHint": "Rôle intégré — ajustez l'accès aux écrans ci-dessous. Le nom et le code sont fixes.",
      "loadingScreens": "Chargement des écrans…"
    },
    "toast": {
      "saved": "Rôle enregistré — les utilisateurs avec ce rôle doivent se reconnecter (ou actualiser) pour mettre à jour la navigation",
      "created": "Rôle créé — attribuez-le aux employés depuis Utilisateurs"
    },
    "assignable": {
      "label": "Rôle",
      "labelRequired": "Rôle *",
      "loading": "Chargement des rôles…",
      "empty": "Aucun rôle disponible",
      "placeholderWithEmail": "Sélectionner un rôle pour la connexion",
      "placeholderOptional": "Sélectionner un rôle (facultatif sans e-mail)",
      "builtInSuffix": "(intégré)",
      "createRolesHint": "Créez des rôles sous",
      "adminRolesLink": "Administration → Rôles",
      "createRolesHintSuffix": "d'abord, puis revenez ici pour les attribuer.",
      "requiredWithEmail": "Obligatoire lorsqu'un e-mail est renseigné — contrôle l'accès à la connexion."
    }
  },
  "permissions": {
    "actions": {
      "view": "Voir",
      "create": "Créer",
      "edit": "Modifier",
      "delete": "Supprimer"
    },
    "hints": {
      "view": "Afficher dans la navigation et ouvrir la page",
      "create": "Afficher les actions de création / ajout sur cet écran",
      "edit": "Afficher les actions de modification sur cet écran",
      "delete": "Afficher les actions de suppression sur cet écran",
      "alwaysVisible": "Toujours visible — aucune permission d'affichage requise ; connexion uniquement",
      "hiddenFromNav": "Masqué dans la navigation",
      "applicationAccess": "Autoriser la connexion et afficher dans le sélecteur d'applications lorsqu'activé avec une autre application"
    },
    "open": "Ouvert",
    "selectAll": "Tout sélectionner",
    "deselectAll": "Tout désélectionner",
    "all": "Tout",
    "none": "Aucun",
    "screen": "Écran",
    "application": "Application",
    "applicationsModule": "Applications",
    "applicationsEnabled": "applications activées",
    "screensVisibleLabel": "écrans visibles",
    "visibleInNav": "{{visible}} sur {{total}} écrans visibles dans la navigation",
    "bulkHint": "Les boutons Tout sélectionner / Tout désélectionner en haut s'appliquent à tous les modules. Chaque en-tête d'accordéon s'applique à ce module uniquement. Les contrôles de colonne et de ligne s'appliquent à cette section du module.",
    "applicationsHint": "Applications répertorie chaque module auquel votre organisation est abonnée. Activez Voir pour chaque application que ce rôle peut ouvrir. Une seule application activée — les utilisateurs y accèdent directement sans sélecteur. Deux ou plus — le sélecteur d'applications apparaît dans la barre latérale.",
    "noSearchResults": "Aucun écran ne correspond à votre recherche.",
    "ariaActionOnScreen": "{{action}} sur {{screen}}"
  },
  "reports": {
    "tabs": {
      "sales": "Ventes",
      "products": "Ventes produits",
      "profit": "Bénéfice",
      "tax": "Taxe",
      "inventory": "Inventaire",
      "lowstock": "Stock faible",
      "expiry": "Expiration",
      "employees": "Ventes par employé"
    },
    "actions": {
      "generate": "Générer"
    },
    "sections": {
      "dailyBreakdown": "Détail quotidien"
    },
    "descriptions": {
      "selectStore": "Sélectionnez un magasin dans l'en-tête pour les rapports financiers",
      "storeSelected": "{{name}} · {{currency}} — les rapports financiers nécessitent un magasin",
      "profitCalculation": "Bénéfice par produit = chiffre d'affaires des ventes (factures) moins le coût (prix d'achat unitaire × quantité vendue). Enregistrez les achats dans l'inventaire afin de mettre à jour le prix de revient ; le prix de vente provient du PDV / produit magasin.",
      "lowStockPrefix": "Utilise les seuils de",
      "lowStockSuffix": "pour le magasin sélectionné. Le coût et la valeur du stock dans l'onglet Inventaire proviennent des achats / du coût du produit magasin."
    },
    "columns": {
      "sku": "SKU",
      "product": "Produit",
      "qtySold": "Qté vendue",
      "revenue": "Revenu",
      "metric": "Indicateur",
      "value": "Valeur",
      "cost": "Coût",
      "profit": "Bénéfice",
      "taxRatePercent": "Taux de taxe %",
      "taxable": "Taxable",
      "taxAmount": "Montant de taxe",
      "onHand": "En stock",
      "alertQty": "Seuil d'alerte",
      "need": "Besoin",
      "batch": "Lot",
      "expiry": "Expiration",
      "qty": "Qté",
      "daysLeft": "Jours restants",
      "employee": "Employé",
      "invoices": "Factures",
      "sales": "Ventes",
      "avgSell": "Vente moyenne",
      "unitCost": "Coût unitaire",
      "marginPercent": "Marge %",
      "ratePercent": "Taux %",
      "tax": "Taxe",
      "lines": "Lignes"
    }
  },
  "inventory": {
    "tabs": {
      "stock": "Stock",
      "movements": "Mouvements",
      "transfers": "Demandes de transfert",
      "backorders": "Reliquats",
      "serials": "Numéros de série",
      "readiness": "Préparation"
    },
    "columns": {
      "serialNumber": "N° de série",
      "product": "Produit",
      "status": "Statut",
      "soldOnInvoice": "Vendu sur facture",
      "warrantyEnd": "Fin de garantie",
      "actions": "Opérations",
      "qty": "Qté",
      "batch": "Lot",
      "expiry": "Expiration",
      "date": "Date",
      "type": "Catégorie",
      "storeRoute": "Magasin / trajet",
      "notes": "Notes",
      "code": "Code",
      "route": "Trajet",
      "lines": "Lignes",
      "created": "Créé",
      "store": "Magasin",
      "reference": "Référence"
    },
    "actions": {
      "ledger": "Grand livre",
      "transfer": "Transférer",
      "adjust": "Ajuster",
      "refresh": "Actualiser",
      "exportPdf": "Exporter PDF",
      "exportExcel": "Exporter Excel",
      "exportCsv": "Exporter CSV",
      "retire": "Retirer",
      "submit": "Soumettre",
      "approve": "Approuver",
      "dispatch": "Expédier",
      "receive": "Réceptionner",
      "allocate": "Allouer",
      "cancel": "Annuler",
      "applyAdjustment": "Appliquer l'ajustement",
      "transferWorkflow": "Transfert (workflow)",
      "submitTransfer": "Soumettre le transfert"
    },
    "messages": {
      "reportExportRequiresPermission": "L'export du rapport nécessite la permission REPORT_VIEW",
      "selectStoreFromHeader": "Sélectionnez un magasin dans l'en-tête.",
      "currentStore": "Magasin actuel :",
      "runningReadinessChecks": "Exécution des contrôles d'intégrité et de préparation de l'inventaire…",
      "openReadinessPrompt": "Ouvrez cet onglet ou cliquez sur Actualiser pour lancer les contrôles de préparation enterprise.",
      "fromStore": "Depuis :",
      "usesTransferWorkflow": "utilise le workflow de transfert",
      "autoApproveFlow": " (approbation automatique, expédition et réception)",
      "pendingApprovalFlow": " (approbation en attente si requise)"
    },
    "howItWorks": {
      "title": "Fonctionnement de l'inventaire",
      "stock": "quantité disponible par produit, lot et date d'expiration (lignes séparées par lot).",
      "adjust": "correction entrée/sortie ; journalisée en ADJUSTMENT_IN / ADJUSTMENT_OUT dans les mouvements.",
      "transfer": "workflow uniquement : créer → soumettre → approuver → expédier → réceptionner (se termine automatiquement si vous pouvez approuver).",
      "heldBillsTitle": "Factures en attente (PDV)",
      "heldBills": "réserve le stock jusqu'au paiement ou à la restauration.",
      "procurementGrnTitle": "Réception achat",
      "procurementGrn": "entrée de stock canonique (la création d'achat héritée est désactivée).",
      "serials": "enregistre les unités ; le passage en caisse PDV transmet par ligne",
      "salesTitle": "Ventes",
      "sales": "le passage en caisse PDV déduit automatiquement le stock (transactions SALE dans les mouvements)."
    },
    "transactionTypes": {
      "adjustmentIn": "Ajustement (+)",
      "adjustmentOut": "Ajustement (-)",
      "transferIn": "Transfert entrant",
      "transferOut": "Transfert sortant",
      "purchase": "Achat",
      "sale": "Vente",
      "return": "Retour"
    },
    "transferStatuses": {
      "draft": "Brouillon",
      "pendingApproval": "En attente d'approbation",
      "approved": "Approuvé",
      "inTransit": "En transit",
      "received": "Reçu",
      "cancelled": "Annulé"
    },
    "adjustment": {
      "increase": "Augmenter le stock (ADJUSTMENT_IN)",
      "decrease": "Diminuer le stock (ADJUSTMENT_OUT)"
    }
  },
  "discounts": {
    "actions": {
      "edit": "Modifier"
    },
    "columns": {
      "catalogDiscountPercent": "Remise catalogue %",
      "couponCode": "Code coupon",
      "discountType": "Type de remise",
      "festivalOffer": "Offre saisonnière",
      "maxUses": "Utilisations max.",
      "offerName": "Nom de l'offre",
      "productName": "Nom du produit",
      "sku": "SKU",
      "timesUsed": "Utilisations",
      "value": "Valeur"
    },
    "discountTypes": {
      "flatAmount": "Montant fixe",
      "percentage": "Pourcentage",
      "percentageWithSymbol": "Pourcentage (%)"
    },
    "empty": {
      "noCoupons": "Aucun coupon trouvé",
      "noOffers": "Aucune offre trouvée",
      "noProducts": "Aucun produit trouvé"
    },
    "help": {
      "couponCheckout": "Utilisé à l'encaissement PDV lorsque le caissier saisit ce code coupon.",
      "flatOffer": "Le montant fixe est soustrait du sous-total du panier (plafonné au sous-total).",
      "percentageOffer": "Le pourcentage est déduit du sous-total du panier éligible.",
      "productCatalogDiscount": "Remise par défaut appliquée à ce produit dans le catalogue (distincte des offres et coupons)."
    },
    "labels": {
      "markFestivalOffer": "Marquer comme offre saisonnière",
      "product": "Produit"
    },
    "modal": {
      "editCoupon": "Modifier le coupon",
      "editOffer": "Modifier l'offre",
      "newCoupon": "Nouveau coupon",
      "newOffer": "Nouvelle offre"
    },
    "search": {
      "coupons": "Rechercher des coupons",
      "offers": "Rechercher des offres",
      "products": "Rechercher des produits"
    },
    "tabs": {
      "coupons": "Coupons",
      "offers": "Offres",
      "products": "Produit %"
    },
    "values": {
      "no": "Non",
      "yes": "Oui"
    }
  },
  "billing": {
    "actions": {
      "backToAdministration": "← Retour à l'administration",
      "current": "Actuel",
      "currentPlan": "Plan actuel",
      "selectPlan": "Sélectionner le plan",
      "upgrade": "Mettre à niveau"
    },
    "billingCycles": {
      "monthly": "Mensuel",
      "yearly": "Annuel"
    },
    "columns": {
      "amount": "Montant",
      "appEnabled": "Application activée",
      "date": "Date",
      "description": "Descriptif",
      "module": "Module",
      "plan": "Forfait",
      "status": "Statut"
    },
    "description": "Plan de l'organisation, abonnements par module, quotas d'utilisation et historique des paiements.",
    "descriptionForModule": "Plans, utilisation et facturation pour {{module}}. L'accès aux fonctionnalités suit le plan de module actif.",
    "empty": {
      "noMeters": "Aucun compteur configuré pour le moment.",
      "noModuleSubscription": "Aucun abonnement {{module}}",
      "noModuleSubscriptions": "Aucun abonnement de module",
      "noPayments": "Aucun paiement pour le moment"
    },
    "labels": {
      "employeesWithValue": "Employés : {{value}}",
      "limits": "Limites — magasins : {{storesUsed}}/{{maxStores}}, employés : {{employeesUsed}}/{{maxEmployees}}, produits : {{productsUsed}}/{{maxProducts}}",
      "noEndDate": "Aucune date de fin",
      "organizationPlan": "Plan de l'organisation",
      "platform": "Plateforme",
      "productsWithValue": "Produits : {{value}}",
      "renewsOrEnds": "Renouvelle / se termine le {{date}}",
      "statusWithValue": "Statut : {{status}}",
      "storesWithValue": "Magasins : {{value}}"
    },
    "loading": {
      "billing": "Chargement de la facturation…",
      "plans": "Chargement des plans…"
    },
    "sections": {
      "changeModulePlan": "Changer le plan du module",
      "currentSubscription": "Abonnement actuel",
      "moduleSubscriptions": "Abonnements de modules",
      "orgWidePlatformPlan": "Plan plateforme de l'organisation",
      "paymentHistory": "Historique des paiements",
      "usageQuotas": "Utilisation et quotas"
    },
    "title": "Facturation et abonnements",
    "titleForModule": "Abonnement {{module}}",
    "values": {
      "free": "Gratuit",
      "no": "Non",
      "pricePerMonth": "{{price}} / mois",
      "pricePerYear": "{{price}} / an",
      "usedOfUnlimited": "{{used}} / illimité",
      "yes": "Oui"
    }
  },
  "subscription": {
    "actions": {
      "current": "Actuel",
      "currentPlan": "Plan actuel",
      "requestCustomPlan": "Demander un plan personnalisé",
      "upgrade": "Mettre à niveau",
      "useFreePlan": "Utiliser le plan gratuit"
    },
    "badges": {
      "alwaysFree": "Toujours gratuit"
    },
    "billingCycles": {
      "monthly": "Mensuel",
      "yearly": "Annuel"
    },
    "columns": {
      "amount": "Montant",
      "date": "Date",
      "details": "Détails",
      "plan": "Forfait",
      "status": "Statut"
    },
    "help": {
      "autoRenew": "Renouvellement automatique mensuel (Razorpay). Lorsqu'il est activé, votre plan est prolongé automatiquement à chaque période de facturation.",
      "customPlanContact": "Nous vous contacterons à l'e-mail de connexion. Les limites et notes sont envoyées à notre équipe pour examen.",
      "customPlanReady": "Votre plan personnalisé est prêt — sélectionnez-le dans la grille des plans ci-dessous.",
      "freePlanUpgrade": "Vous utilisez le plan gratuit. Mettez à niveau à tout moment pour plus de magasins, d'employés et de produits.",
      "requestPendingReview": "Demande en attente d'examen (soumise le {{date}})."
    },
    "labels": {
      "status": "Statut : {{status}}",
      "validUntil": "Valide jusqu'au {{date}}"
    },
    "loading": "Chargement...",
    "periods": {
      "month": "mois",
      "year": "an"
    },
    "sections": {
      "billingHistory": "Historique de facturation",
      "currentPlan": "Plan actuel",
      "needCustomPlan": "Besoin d'un plan personnalisé ?",
      "planUsage": "Utilisation du plan"
    },
    "values": {
      "free": "Gratuit",
      "freePlan": "Plan gratuit"
    }
  },
  "stores": {
    "breadcrumbs": {
      "pos": "PDV",
      "stores": "Magasins"
    },
    "columns": {
      "city": "Ville",
      "code": "Code",
      "country": "Pays",
      "currency": "Devise",
      "name": "Nom",
      "phone": "Téléphone",
      "status": "Statut",
      "tax": "Taxe"
    },
    "empty": {
      "noStores": "Aucun magasin trouvé"
    },
    "searchPlaceholder": "Rechercher des magasins",
    "taxPricing": {
      "exclusive": "Taxes exclues",
      "inclusive": "Taxes incluses"
    }
  },
  "suppliers": {
    "columns": {
      "name": "Nom",
      "phone": "Téléphone",
      "outstanding": "Encours",
      "status": "Statut"
    }
  },
  "pages": {
    "pinPageToFavorites": "Pin page à favorites",
    "administration": "Gestion",
    "brands": "Brands",
    "categories": "Categories",
    "customers": "Clients",
    "manageCustomerRecordsAndWalletBalances": "Manage client records et wallet balances",
    "noCustomersYet": "No clients yet",
    "addYourFirstCustomerToTrack": "Add votre first client à track sales, loyalty, et wallet balance.",
    "discountsOffers": "Discounts & Offers",
    "productCatalogDiscount": "Produit catalog discount",
    "manageOffersCouponCodesAndProduct": "Manage offers, coupon codes, et produit-level discounts",
    "employees": "Employés",
    "appAccess": "App access",
    "password": "Mot de passe",
    "reportingLine": "Rapporting line",
    "employmentStatus": "Emploi status",
    "assignedStores": "Assigned magasins",
    "setANewPasswordGenerateOne": "Set a new password, generate one, ou email credentials à le employé.",
    "inventory": "Inventaire",
    "adjustStock": "Adjust stock",
    "transferStock": "Transfer stock",
    "newTransferRequest": "New transfer request",
    "registerSerialNumber": "Register serial number",
    "invoices": "Factures",
    "invoiceHistory": "Facture history",
    "salesReturn": "Sales return",
    "organization": "Organisation",
    "dashboard": {
      "title": "Tableau de bord",
      "posTitle": "Tableau de bord PDV",
      "description": "KPI à l'échelle de l'entreprise et vue financière par magasin",
      "posDescription": "Ventes magasin, stocks et opérations point de vente",
      "summaryLabel": "{{storeCount}} magasins · {{employeeHeadcount}} employés",
      "today": "Aujourd'hui",
      "thisMonth": "Ce mois-ci",
      "invoicesToday": "Factures du jour",
      "selectStoreForKpis": "Sélectionnez un magasin pour voir les KPI au niveau magasin.",
      "lowStockAlert": "{{count}} produit(s) sous le seuil de réapprovisionnement — consultez les alertes stock."
    },
    "salesByStore": "Ventes par magasin",
    "storeKpis": "KPI du magasin",
    "todaySInvoices": "Today's Factures",
    "todaySSales": "Today's Sales",
    "monthSales": "Ventes du mois",
    "products": "Produits",
    "eachStoreShownInItsOwn": "Each magasin shown in its own currency — never merged",
    "productAlerts": "Produit alerts",
    "lowStockAlert": "Low stock alert",
    "addBrand": "Ajouter une marque",
    "addUnit": "Ajouter une unité",
    "noProductsYet": "No produits yet",
    "addProductsToYourCatalogFor": "Add produits à votre catalog pour POS et inventory.",
    "reports": "Rapports",
    "totalSales": "Total Sales",
    "tax": "Fiscalité",
    "discounts": "Discounts",
    "revenue": "Chiffre d’affaires",
    "cost": "Cost",
    "grossProfit": "Gross Profit",
    "margin": "Margin %",
    "taxableAmount": "Taxable Amount",
    "totalTax": "Total Tax",
    "stockValue": "Stock Value",
    "lowStock": "Low Stock",
    "lowStockItems": "Low stock items",
    "store": "Magasin",
    "rolesScreenAccess": "Rôles et accès aux écrans",
    "rolesIntro": "Créez des rôles et choisissez quels écrans chaque rôle peut consulter, créer, modifier ou supprimer. Attribuez les rôles aux employés depuis Utilisateurs après l'enregistrement.",
    "storeProducts": "Magasin Produits",
    "linkCatalogProductsToAStore": "Link catalog produits à a magasin avec that magasin's selling price et facultatif barcode",
    "stores": "Magasins",
    "retailLocationsWarehousesAndPosOutlets": "Retail locations, entrepôts, et POS outlets",
    "subscription": "Subscription",
    "requestCustomPlan": "Request custom plan",
    "suppliers": "Fournisseurs",
    "taxRates": "Tax rates",
    "taxRules": "Règles fiscales",
    "countryStateTaxRulesUsedBy": "Country/state tax rules utiliserd by magasins at checkout",
    "units": "Units"
  },
  "labels": {
    "closeSidebar": "Fermer la barre latérale",
    "closeMenu": "Fermer le menu",
    "toggleTheme": "Changer le thème",
    "dateFormat": "Date format",
    "timeFormat": "Time format",
    "dateAmpTimeFormat": "Date &amp; time format",
    "module": "Module",
    "billingCycle": "Billing cycle",
    "brandName": "Brand name *",
    "name": "Nom *",
    "phone": "Téléphone",
    "email": "Email",
    "address": "Address",
    "transaction": "Transaction",
    "notes": "Notes",
    "offerName": "Offer name *",
    "discountType": "Remise type *",
    "minimumCartAmount": "Minimum cart amount",
    "specificProductOptional": "Specific produit (optional)",
    "couponCode": "Coupon code *",
    "maximumUses": "Maximum utilisers",
    "discountPercentage": "Remise percentage *",
    "flatDiscountAmountRequired": "Montant de remise fixe *",
    "eGWeekendSale": "e.g. Weekend sale",
    "optional": "Facultatif",
    "allProductsIfEmpty": "All produits if empty",
    "eGSave10": "e.g. SAVE10",
    "leaveEmptyForUnlimited": "Congé empty pour unlimited",
    "validFrom": "Valable à partir du",
    "validUntil": "Valable jusqu'au",
    "firstName": "Prénom *",
    "lastName": "Last name",
    "initialPassword": "Initial password",
    "confirmPassword": "Confirmer le mot de passe",
    "status": "Statut",
    "comments": "Commentaires",
    "loginEmailOptional": "Login email (facultatif)",
    "optionalAutoGeneratedIfBlank": "Facultatif — auto-generated if blank",
    "stockLine": "Stock line *",
    "direction": "Direction *",
    "quantity": "Quantity *",
    "batchNumber": "Batch number",
    "expiryDate": "Date d'expiration",
    "reasonNotes": "Reason / notes",
    "stockLineToTransfer": "Stock line à transfer *",
    "toStore": "To magasin *",
    "product": "Produit *",
    "serialNumber": "Serial number *",
    "imeiOptional": "IMEI (facultatif)",
    "selectProductBatchRow": "Select produit / batch row",
    "optionalUseForBatchTrackedProducts": "Optional — utiliser pour batch-tracked produits",
    "eGDamagedGoodsStockCount": "e.g. Damaged goods, stock count correction",
    "selectProductBatch": "Select produit / batch",
    "selectDestination": "Select destination",
    "destination": "Destination",
    "reasonOptional": "Reason (facultatif)",
    "returnQty": "Return qty",
    "reason": "Motif",
    "whyIsThisInvoiceBeingVoided": "Why is ce facture being voided?",
    "name2": "Nom",
    "orgCode": "Code de l'organisation",
    "gst": "GST",
    "city": "Ville",
    "state": "State",
    "pincode": "Pincode",
    "eGFat": "e.g. FAT",
    "alertWhenQuantityAtOrBelow": "Alert when quantity at ou below *",
    "sku": "SKU *",
    "barcode": "Code-barres",
    "category": "Catégorie",
    "sellingPrice": "Selling price *",
    "mrp": "MRP",
    "taxRuleStoreCheckout": "Tax rule (magasin checkout)",
    "discount": "Remise %",
    "unitName": "Unit name *",
    "symbol": "Symbole",
    "defaultFromStoreCountry": "Default de magasin country",
    "code": "Code *",
    "roleName": "Nom du rôle *",
    "description": "Descriptif",
    "eGSupervisor": "p. ex. SUPERVISEUR",
    "eGFloorSupervisor": "p. ex. Superviseur de vente",
    "whatThisRoleIsFor": "À quoi sert ce rôle",
    "store": "Magasin",
    "storeBarcodeUniquePerStore": "Magasin barcode (unique per magasin)",
    "selectStore": "Select magasin…",
    "optionalUsedForPosScanAt": "Optional — utiliserd pour POS scan at ce magasin",
    "taxMode": "Tax mode",
    "prices": "Prices",
    "attendanceLocationOverride": "Remplacement du lieu de présence",
    "attendanceLocationOverrideHint": "Lorsque défini, remplace le lieu de la société pour les employés affectés à ce magasin.",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "geoRadiusMeters": "Rayon (m)",
    "stores": "Magasins",
    "employees": "Employés",
    "products": "Produits",
    "billingCyclePaidPlans": "Billing cycle (paid plans)",
    "yourEmailLoginAccount": "Your email (login compte)",
    "phoneOptional": "Phone (facultatif)",
    "storesNeeded": "Magasins needed",
    "employeesNeeded": "Employés needed",
    "productsNeeded": "Produits needed",
    "requirements": "Requirements",
    "code2": "Code",
    "country": "Pays",
    "rate": "Rate % *",
    "taxName": "Nom de la taxe *",
    "country2": "Country *",
    "stateCode": "State code",
    "selectTaxMode": "Sélectionner une taxe mode",
    "eGPiece": "e.g. Piece",
    "eGPcs": "e.g. pcs",
    "role": "Rôle",
    "login": "Login",
    "points": "Points",
    "wallet": "Wallet",
    "price": "Prix",
    "unit": "Unité",
    "brand": "Brand",
    "system": "Système"
  },
  "employmentStatuses": {
    "ACTIVE": "Actif",
    "INACTIVE": "Inactif",
    "TERMINATED": "Licencié",
    "RESIGNED": "Démissionnaire",
    "RETIRED": "Retraité"
  },
  "employees": {
    "requirePasswordChangeOnNextSignIn": "Exiger le changement du mot de passe à la prochaine connexion",
    "temporaryPasswordWillBeEmailed": "Si aucun mot de passe n'est défini, un mot de passe temporaire est envoyé par e-mail et l'utilisateur devra le changer à sa première connexion.",
    "statusTimeline": "Chronologie du statut"
  },
  "invoices": {
    "columns": {
      "invoiceNumber": "Facture n°",
      "date": "Date",
      "total": "Total",
      "payment": "Paiement",
      "status": "Statut"
    },
    "actions": {
      "print": "Imprimer",
      "pdf": "PDF",
      "void": "Annuler",
      "voidInvoice": "Annuler la facture",
      "restore": "Restaurer"
    },
    "selectStoreToViewHistory": "Sélectionnez un magasin dans l'en-tête pour voir l'historique des factures.",
    "historyDescription": "{{store}} · {{currency}} — liste, impression, PDF et retours de vente",
    "invoiceTitle": "Facture {{number}}",
    "invoiceTitleFallback": "Facture",
    "detail": {
      "date": "Date :",
      "currency": "Devise :",
      "subtotal": "Sous-total :",
      "tax": "Taxe :",
      "total": "Total :",
      "paid": "Payé :"
    },
    "payments": "Paiements",
    "lineItems": "Lignes",
    "taxPercent": " ({{percent}} % taxe)",
    "returnHelp": "Le stock sera restauré. Le remboursement ajuste le statut du paiement.",
    "returnHelpWithWallet": "Le stock sera restauré. Le remboursement ajuste le statut du paiement et crédite le portefeuille client pour les paiements par portefeuille.",
    "refundPaymentWalletCredit": "Rembourser le paiement (crédit portefeuille si payé via WALLET)",
    "soldQuantity": "Vendu : {{quantity}}",
    "voidTitle": "Annuler {{number}}",
    "voidHelp": "Le stock sera restauré et la facture marquée annulée. Une approbation du superviseur peut être requise."
  },
  "productAlerts": {
    "columns": {
      "product": "Produit",
      "sku": "SKU",
      "stockAlertAt": "Stock / Seuil d'alerte",
      "active": "Actif",
      "lastNotified": "Dernière notification"
    },
    "confirmRemove": "Supprimer cette alerte ?",
    "selectStoreToManage": "Sélectionnez un magasin dans l'en-tête pour gérer les alertes de stock faible.",
    "description": "Seuils de stock faible pour {{store}}. Les alertes apparaissent dans les notifications et se répètent au maximum une fois toutes les 24 heures."
  },
  "storeProducts": {
    "columns": {
      "product": "Produit",
      "sku": "SKU",
      "barcode": "Code-barres",
      "storeBarcode": "Code-barres magasin",
      "sellingPrice": "Prix de vente",
      "mrp": "MRP",
      "status": "Statut"
    },
    "storeProductFallback": "Produit magasin",
    "infoTitle": "Qu'est-ce qu'un produit magasin ?",
    "infoPrefix": "Votre catalogue",
    "infoCatalogScope": "Produits est global à l'organisation (SKU, nom, prix par défaut).",
    "storeProductTerm": "Un produit magasin",
    "infoDefinition": "est le même article activé pour un magasin avec le prix de vente, le MRP et le code-barres optionnel de ce magasin (unique dans ce magasin). Le PDV et l'inventaire de ce magasin utilisent ces valeurs ; le scan vérifie le code-barres magasin avant le code-barres catalogue. Créez d'abord le produit dans Produits, puis ajoutez-le ici pour chaque magasin.",
    "sellingPriceCurrency": "Prix de vente ({{currency}}) *",
    "mrpCurrency": "MRP ({{currency}})",
    "storeBarcodeHelp": "Chaque code-barres magasin ne peut être utilisé qu'une seule fois dans ce magasin. Laissez vide pour scanner plutôt le code-barres catalogue depuis Produits."
  },
  "categories": {
    "columns": {
      "name": "Nom",
      "status": "Statut"
    },
    "breadcrumbs": {
      "pos": "PDV"
    }
  },
  "formActions": {
    "saveOffer": "Enregistrer l'offre",
    "saveCoupon": "Enregistrer le coupon",
    "addOffer": "Ajouter une offre",
    "addCoupon": "Ajouter un coupon",
    "submitRequest": "Soumettre la demande",
    "submitReturn": "Soumettre le retour"
  },
  "listActions": {
    "addCustomer": "Ajouter un client",
    "addProduct": "Ajouter un produit",
    "addEmployee": "Ajouter un employé",
    "addCategory": "Ajouter une catégorie",
    "addStore": "Ajouter un magasin",
    "addUnit": "Ajouter une unité",
    "addTax": "Ajouter une taxe",
    "addTaxRule": "Ajouter une règle",
    "addStoreProduct": "Ajouter un tarif",
    "addAlert": "Ajouter une alerte",
    "addBrand": "Ajouter une marque",
    "refundReturn": "Rembourser / Retour",
    "registerSerial": "Enregistrer un numéro de série",
    "newCustomer": "Nouveau client",
    "editCustomer": "Modifier le client",
    "newProduct": "Nouveau produit",
    "editProduct": "Modifier le produit",
    "newEmployee": "Nouvel employé",
    "editEmployee": "Modifier l'employé",
    "newCategory": "Nouvelle catégorie",
    "editCategory": "Modifier la catégorie",
    "newStore": "Nouveau magasin",
    "editStore": "Modifier le magasin",
    "newUnit": "Nouvelle unité",
    "editUnit": "Modifier l'unité",
    "newTax": "Nouvelle taxe",
    "editTax": "Modifier la taxe",
    "newTaxRule": "Nouvelle règle fiscale",
    "editTaxRule": "Modifier la règle fiscale",
    "newStoreProduct": "Nouveau tarif magasin",
    "editStoreProduct": "Modifier le tarif magasin",
    "newBrand": "Nouvelle marque",
    "editBrand": "Modifier la marque",
    "newSupplier": "Nouveau fournisseur",
    "editSupplier": "Modifier"
  }
}
